import '/vercel/path0/node_modules/.pnpm/@chromatic-com+storybook@1.6.1_react@18.3.1/node_modules/@chromatic-com/storybook/dist/manager.mjs';